<template>
  <div>
    <div class="text-xl font-black py-2">7. Marketing & Communication Strategy</div>

    <!-- Sub section 1-->
    <div class="py-2 text-lg font-black">Lead Generation</div>
    <div class="py-2">What are you currently doing to generate leads?</div>
    <div class="flex">
      <!-- Sub section 1 -->
      <div class="mt-8 p-4 w-1/2 bg-gray-100 border mr-8">
        <div class="flex justify-between p-4 mr-4 items-center border-b">
          <div class="font-black py-2 flex-grow text-lg">Print Marketing</div>
          <div class="px-4 uppercase text-lg">Yes</div>
        </div>
        <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
          <review-question-component v-model="form.questions[page][sectionStart][index]" container-class="flex justify-between items-center w-full px-4 pb-2" :showMandatory="showMandatory"></review-question-component>
        </div>
      </div>

      <!-- Sub section 2 -->
      <div class="mt-8 p-4 w-1/2 bg-gray-100 border ml-8">
        <div class="flex justify-between p-4 mr-4 items-center border-b">
          <div class="font-black py-2 flex-grow text-lg">Digital Marketing</div>
          <div class="px-4 uppercase text-lg">Yes</div>
        </div>
        <div v-for="(question2, index2) in form.questions[page][sectionStart+1]" :key="index2">
          <review-question-component v-model="form.questions[page][sectionStart+1][index2]" container-class="flex justify-between items-center w-full px-4 pb-2" :showMandatory="showMandatory"></review-question-component>
        </div>
      </div>
    </div>

    <hr class="border-b my-4" />

    <!-- Sub section 3-->
    <div class="pt-2">
      <div v-for="(question3, index3) in form.questions[page][sectionStart+2]" :key="index3">
        <review-question-component v-model="form.questions[page][sectionStart+2][index3]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>

  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  }
}
</script>
